import { useEffect, useRef } from "react";
import Modal, { ModalProps } from "../Modal/Modal";
import Button from "../Button/Button";
import usePosOrderHook from "@/shared/hooks/usePosOrderHook";
import useIsOrderEditingHook from "@/shared/hooks/useIsOrderEditingHook";
import { useTranslation } from "react-i18next";

const PosOrderPendingPaymentDecisionModal = ({
  onExit,
  ...props
}: ModalProps) => {
  const { t } = useTranslation();
  const { handlePostOrder, isPending } = usePosOrderHook();
  const { setEditOrder, editOrder, isOrderEditing } = useIsOrderEditingHook();
  const editOrderBackUp = useRef(editOrder);

  useEffect(() => {
    const fn = async () => {
      await handlePostOrder()
        .then(() => {
          onExit();
        })
        .catch(() => {
          setEditOrder(editOrderBackUp.current);
        });
    };
    if (isOrderEditing === false) {
      fn();
    }
  }, [isOrderEditing]);

  const handleNewOrder = async () => {
    setEditOrder({});
  };

  return (
    <Modal onExit={onExit} {...props}>
      <h4>
        {t("pendingPaymentOrderTitle", {
          publicOrderNumber: editOrder?.order_information?.public_order_number,
        })}
      </h4>
      <div className="flex gap-4">
        <Button
          variant="secondary"
          onClick={() => onExit()}
          isPending={isPending}
          style={{
            width: "100%",
            height: "5rem",
            borderRadius: "0.5rem",
            fontSize: "2rem",
            fontWeight: "600",
          }}
        >
          {t("close")}
        </Button>
        <Button
          onClick={handleNewOrder}
          isPending={isPending}
          style={{
            width: "100%",
            height: "5rem",
            borderRadius: "0.5rem",
            fontSize: "2rem",
            fontWeight: "600",
          }}
        >
          {t("createNewOrder")}
        </Button>
      </div>
    </Modal>
  );
};

export default PosOrderPendingPaymentDecisionModal;
